import { Component, OnInit, OnDestroy, Renderer2, NgZone } from "@angular/core"
import { ActivatedRoute } from "@angular/router"
import { Subscription } from "rxjs"
import { environment } from "src/environments/environment"
import { ApiService } from "../api.service"
import Swal from "sweetalert2"

declare var $: any

@Component({
	selector: 'course',
	templateUrl: './course.component.html',
	styleUrls: ['./course.component.scss']
})

export class CourseComponent implements OnInit, OnDestroy {

	title = environment.title

	userID = 0
	userOrg = 0
	userAI = false
	courseID = 0
	courseName: { [key: string]: string } = {}
	courseNameView = ''
	courseType: undefined | 'estandar' | 'idiomas'
	courseLanguage: undefined | 'english' | 'chinese'
	
	courseTranslations: string[] = []
	courseMultitransl = false
	courseCurrentTransl = 'es'
	
	courseCategory = 0
	courseHours = 0
	courseLocked = false
	courseLockedTime = null

	courseLoading = false
	courseError = false
	courseLoadingStr = ''
	courseErrorStr = ''
	courseFormShow = false
	
	heading = false
	multimedia = false
	files = false
	tables = false
	activityTest = false
	glossary = false
	objectives = false
	summary = false

	unitInfo = false
	lessonInfo = false
	courseDuration = false
	
	bsExporting = false
	courseExportType : 'desktop' | 'mobile' | 'pdf' = 'desktop'
	courseExportLanguage : 'es' | 'en' | 'cn' = 'es'
	courseExport = false
	coursePreview = false
	
	courseBackup = false
	courseBackingUp = false

	report = false
	reportType = ''
	reportWriter = ''

	moveUnit = false
	moveUnitId = 0
	moveUnitName = ''

	checkLinks = false
	checkLinksCourseId = 0

	nodesTextSearch = false
	nodesTextSearchCourseId = 0

	multimediaReport = false
	multimediaReportCourseId = 0

	generateQuestionsMoodle = false
	generateQuestionsMoodleCourseId = 0

	courseLock = false

	checkErrors = false
	courseHasErrors = false
	courseErrors = []

	runningJob: any | null = null
	
	generateUnitID = 0
	generateUnitName = ''
	
	unitID = 0
	lessonID = 0
	headingID = 0
	headingType = ''
	activityTestID = 0
	activityTestType = ''
	glossaryID = 0
	objectivesID = 0
	summaryID = 0

	getCourseInfoSub = new Subscription
	insertNodeSub = new Subscription
	moveNodeSub = new Subscription
	updateNodePositionsSub = new Subscription
	editNodeSub = new Subscription
	emptyNodeSub = new Subscription
	deleteNodeSub = new Subscription
	courseUnlockRequestSub = new Subscription
	checkErrorsSub = new Subscription
	unitRecommendMultimediaSub = new Subscription
	lessonRecommendMultimediaSub = new Subscription
	headingSummarizeContentAISub = new Subscription
	lessonSummarizeHeadingsAISub = new Subscription
	generateHeadingContentAISub = new Subscription
	generateLessonHeadingsAISub = new Subscription
	generateLessonHeadingImagesAISub = new Subscription
	generateActivitiesAISub = new Subscription
	generateTestAISub = new Subscription
	generateUnitSummaryAISub = new Subscription
	generateUnitGlossaryAISub = new Subscription
	translateLessonAISub = new Subscription
	exportBrainscormSub = new Subscription
	jobAddSub = new Subscription
	jobStatusSub = new Subscription

	jsTree: any = $.jstree!
	treeDataUrl = ''
	treeNonDragTypes = ['unit_create', 'multimedia', 'files', 'tables', 'objectives', 'summary', 'glossary', 'activity', 'test',]
	treeNonRenameTypes = ['unit_create', 'multimedia', 'files', 'tables', 'objectives', 'summary', 'glossary']

	headingContentEditorId = 'heading-content-editor'
	summaryContentEditorId = 'summary-content-editor'

	constructor(private dataService: ApiService, private renderer: Renderer2, private route: ActivatedRoute, private zone: NgZone) {}

	ngOnInit() {
		this.userID = this.dataService.getUserID()
		this.userOrg = this.dataService.getUserOrg()
		this.userAI = this.dataService.getUserAI()
		
		this.courseID = Number(this.route.snapshot.paramMap.get('id'))
		this.dataService.setCourseID(this.courseID)
		this.courseLoading = true
		this.courseLoadingStr = 'Cargando...'

		this.treeDataUrl = `${this.dataService.baseUrl}/php/common/tree/course_nodes.php`
		
		this.getCourseInfoSub = this.dataService.getCourseInfo(this.courseID, this.userID)
		.subscribe({
			next: (data) => {
				// console.log(data)
				
				if (data.error) {
					this.courseError = true
					this.courseErrorStr = data.error
				} else {
					this.courseTranslations = data.translations
					this.courseMultitransl = this.courseTranslations.length > 1

					if (this.courseMultitransl) {
						this.courseName = data.name
						this.courseNameView = data.name[this.courseCurrentTransl]
					} else {
						this.courseName = data.name
						this.courseNameView = data.name
					}
					this.dataService.setCourseName(this.courseNameView)
					document.title = `${this.title}: ${this.courseNameView}`
					
					this.courseType = data.type
					if (this.courseType == 'idiomas') {
						if (this.courseNameView.toLowerCase().includes('inglés')) this.courseLanguage = 'english'
						else if (this.courseNameView.toLowerCase().includes('chino')) this.courseLanguage = 'chinese'
					}
					
					this.courseCategory = data.category
					this.courseHours = data.hours
					this.courseLocked = data.locked
					this.courseLockedTime = data.lockedtime
				}

				// console.log(this.courseError)
				// console.log(this.courseErrorStr)
				if (this.courseError) return
				// this.courseLoading = false
				// this.jstreeLoad()

				this.courseLoadingStr = 'Revisando errores...'
				this.checkErrorsSub = this.dataService.checkCourseErrors(this.courseID, this.courseMultitransl, this.courseCurrentTransl)
				.subscribe({
					next: (data) => {
						console.log(data)
						this.courseLoading = false
						this.courseHasErrors = data.errors.length > 0
						this.courseErrors = data.errors
						this.jstreeLoad()
					},
					error: (e) => {
						console.log(e)
						this.courseLoading = false
						this.courseHasErrors = false
						this.courseErrors = []
						this.jstreeLoad()
					},
				})

				this.dataService.getCourseRunningJobs(this.courseID)
				.subscribe({
					next: (data) => {
						// console.log(data)
						this.runningJob = data
					},
					error: (e) => {
						console.log(e)
					}
				})
			},
			error: (e) => {
				console.log(e)
				this.courseError = true
			}
		})
	}

	ngOnDestroy() {
		this.getCourseInfoSub?.unsubscribe()
		this.insertNodeSub?.unsubscribe()
		this.moveNodeSub?.unsubscribe()
		this.updateNodePositionsSub?.unsubscribe()
		this.editNodeSub?.unsubscribe()
		this.emptyNodeSub?.unsubscribe()
		this.deleteNodeSub?.unsubscribe()
		this.checkErrorsSub?.unsubscribe()
		this.generateHeadingContentAISub?.unsubscribe()
		this.generateLessonHeadingsAISub?.unsubscribe()
		this.generateLessonHeadingImagesAISub?.unsubscribe()
		this.generateActivitiesAISub?.unsubscribe()
		this.generateTestAISub?.unsubscribe()
		this.generateUnitSummaryAISub?.unsubscribe()
		this.generateUnitGlossaryAISub?.unsubscribe()
		this.translateLessonAISub?.unsubscribe()
		this.exportBrainscormSub?.unsubscribe()
		this.jobAddSub?.unsubscribe()
		this.jobStatusSub?.unsubscribe()
	}

	insertNode(node: any, position: number, parent: number) {
		console.log(node)
		let name = node.text
		let type = node.type
		
		this.insertNodeSub = this.dataService.insertNode(name, type, position, parent)
		.subscribe({
			next: (id) => {
				console.log(id)
				console.log(node)
				// this.jstreeUpdate()
				this.jstreeLoadNode(node.parent)
			},
			error: (e) => {
				console.log(e)
				Swal.fire('Error', 'No se ha podido insertar el nodo. Por favor, inténtelo de nuevo.', 'error')
			},
		})
	}

	moveNode(node: any, oldPosition: number, oldParent: number, newPosition: number, newParent: number) {
		let type = node.type
		let id = +node.data.id

		this.moveNodeSub = this.dataService.moveNode(id, type, oldPosition, oldParent, newPosition, newParent)
		.subscribe({
			next: (id) => {
				console.log(id)
				this.jstreeUpdate()
			},
			error: (e) => {
				console.log(e)
				Swal.fire('Error', 'No se ha podido mover el nodo. Por favor, inténtelo de nuevo.', 'error')
			},
		})
	}

	updateNodePositions(nodes: any) {
		console.log(nodes)

		this.updateNodePositionsSub = this.dataService.updateNodePositions(nodes)
		.subscribe({
			next: (data) => {
				console.log(data)
				this.jstreeUpdate()
			},
			error: (e) => {
				console.log(e)
			}
		})
	}

	editNode(node: any) {
		// console.log(node)
		let type = node.type
		let id = +node.data.id
		let name = node.text

		if (this.courseMultitransl) {
			let nameData = node.original.name
			nameData[this.courseCurrentTransl] = name
			name = nameData
			// name = JSON.stringify(nameData)
		}

		this.editNodeSub = this.dataService.editNode(id, type, name)
		.subscribe({
			next: (data) => {
				console.log(data)
				// this.jstreeUpdate()
				this.jstreeLoadNode(node)
			},
			error: (e) => {
				console.log(e)
			},
		})
	}

	emptyNode(node: any) {
		let type = node.type
		let title = 'Vaciar nodo'
		let msg = '¿Está seguro que quiere borrar todos los hijos de este nodo?'
		if (type == 'unit') {
			title = 'Vaciar unidad'
			msg = '¿Está seguro que quiere borrar todos los nodos descendientes de esta unidad (lecciones, glosarios, etc.)?'
		}
		else if (type == 'lesson') {
			title = 'Vaciar lección'
			msg = '¿Está seguro que quiere borrar todos los nodos descendientes de esta lección (enunciados, actividades, etc.)?'
		}

		Swal.fire({
			title: title,
			text: msg,
			icon: 'question',
			showCancelButton: true,
			cancelButtonText: 'Cancelar'
		}).then((result) => {
			// console.log(result)
			if (!result.isConfirmed) return

			// console.log(node)
			let id = +node.data.id
			// let position = +node.original.position
			// let parent = +node.data.parent

			this.emptyNodeSub = this.dataService.emptyNode(id, type)
			.subscribe({
				next: (data) => {
					console.log(data)
					this.jstreeUpdate()
				},
				error: (e) => {
					console.log(e)
				},
			})
		})
	}

	deleteNode(node: any) {
		let type = node.type
		let title = 'Eliminar nodo'
		let msg = '¿Está seguro que quiere eliminar este nodo?'
		if (type == 'unit') {
			title = 'Eliminar unidad'
			msg = '¿Está seguro que quiere eliminar esta unidad? También se eliminarán todos los nodos descendientes (lecciones, glosarios, etc.)'
		}
		else if (type == 'lesson') {
			title = 'Eliminar lección'
			msg = '¿Está seguro que quiere eliminar esta lección? También se eliminarán todos los nodos descendientes (enunciados, actividades, etc.)'
		}
		
		Swal.fire({
			title: title, 
			text: msg, 
			icon: 'question',
			showCancelButton: true,
			cancelButtonText: 'Cancelar'
		}).then((result) => {
			// console.log(result)
			if (!result.isConfirmed) return

			Swal.fire({
				title: title,
				html: "<p>Eliminando...</p>",
				timer: 2000,
				showConfirmButton: false,
				allowEscapeKey: false,
				allowOutsideClick: false,
				didOpen: () => {
					Swal.showLoading()
					Swal.stopTimer()
					let htmlContainer = Swal.getHtmlContainer()!

					// console.log(node)
					let id = +node.data.id
					let position = +node.original.position
					let parent = +node.data.parent

					this.deleteNodeSub = this.dataService.deleteNode(id, type, position, parent)
					.subscribe({
						next: (result) => {
							console.log(result)
							if (result) {
								htmlContainer.innerHTML = "<p class='text-success'><i class='fas fa-check'></i><span>¡Eliminado!</span></p>"
								Swal.hideLoading()
								Swal.resumeTimer()
							}
						},
						error: (e) => {
							console.log(e)
							Swal.fire({
								title: 'Error',
								html: '' + e.error.message + '<br>¿Quieres intentarlo de nuevo?',
								icon: 'error',
								showCancelButton: true,
								cancelButtonText: 'Cancelar'
							}).then((result) => {
								// console.log(result)
								if (result.isConfirmed) this.deleteNode(id)
								else this.jstreeUpdate()
							})
						},
					})
				},
			}).then((result) => {
				console.log(result)
				this.jstreeUpdate()
			})
		})
	}

	jstreeLoad() {
		$(() => {
			let jstree: any = $('#jstree')

			// Icons
			let folderIcon = 'fas fa-folder me-2'
			let folderOpenIcon = 'fas fa-folder-open me-2'
			let folderAddIcon = 'fas fa-folder-plus me-2'
			let fileIcon = 'far fa-file me-2'
			let fileExclamationIcon = 'fas fa-file-circle-exclamation me-2'
			let fileQuestionIcon = 'fas fa-file-circle-question me-2'
			let fileCheckIcon = 'fas fa-file-circle-check me-2'
			let checkSquareIcon = 'fas fa-square-check me-2'
			let checkCircleIcon = 'fas fa-circle-check me-2'
			let listIcon = 'fas fa-list me-2'
			let listCheckIcon = 'fas fa-list-check me-2'
			let imageIcon = 'fas fa-image me-2'
			let videoIcon = 'fas fa-film me-2'
			let photoVideoIcon = 'fas fa-photo-video me-2'
			let archiveIcon = 'fas fa-archive me-2'
			let tableIcon = 'fas fa-table me-2'
			let circlePlusIcon = 'fas fa-circle-plus text-success me-2'
			let editIcon = 'fas fa-edit me-2'
			let arrowRightIcon = 'fas fa-arrow-right me-2'
			let trashCanIcon = 'fas fa-trash-can text-danger me-2'
			let searchIcon = 'fas fa-search me-2'
			let magicWandIcon = 'fas fa-magic-wand-sparkles me-2'
			let languageIcon = 'fas fa-language me-2'

			let circlePlusIconHtml = `<i class="${circlePlusIcon}"></i>`
			let fileIconHtml = `<i class="${fileIcon}"></i>`
			let fileExclamationIconHtml = `<i class="${fileExclamationIcon}"></i>`
			let fileQuestionIconHtml = `<i class="${fileQuestionIcon}"></i>`
			let fileCheckIconHtml = `<i class="${fileCheckIcon}"></i>`
			let editIconHtml = `<i class="${editIcon}"></i>`
			let trashCanIconHtml = `<i class="${trashCanIcon}"></i>`
			let imageIconHtml = `<i class="${imageIcon}"></i>`
			let videoIconHtml = `<i class="${videoIcon}"></i>`
			let photoVideoIconHtml = `<i class="${photoVideoIcon}"></i>`
			let searchIconHtml = `<i class="${searchIcon}"></i>`
			let magicWandIconHtml = `<i class="${magicWandIcon}"></i>`
			let languageIconHtml = `<i class="${languageIcon}"></i>`

			let folderAddIconHtml =
			`<span class="fa-layers ms-4 me-2">
				<i class="${folderIcon}"></i>
				<i class="${circlePlusIcon}" data-fa-transform="shrink-4 down-12 right-12"></i>
			</span>`
			let folderEditIconHtml =
			`<span class="fa-layers ms-4 me-2">
				<i class="${folderIcon}"></i>
				<i class="${editIcon}" data-fa-transform="shrink-4 down-12 right-12"></i>
			</span>`
			let folderMoveIconHtml =
			`<span class="fa-layers ms-4 me-2">
				<i class="${folderIcon}"></i>
				<i class="${arrowRightIcon}" data-fa-transform="shrink-4 down-12 right-12"></i>
			</span>`
			let folderDeleteIconHtml =
			`<span class="fa-layers ms-4 me-2">
				<i class="${folderIcon}"></i>
				<i class="${trashCanIcon}" data-fa-transform="shrink-4 down-12 right-12"></i>
			</span>`
			let fileAddIconHtml =
			`<span class="fa-layers ms-4 me-2">
				<i class="${fileIcon}"></i>
				<i class="${circlePlusIcon}" data-fa-transform="shrink-4 down-12 right-12"></i>
			</span>`
			let fileEditIconHtml =
			`<span class="fa-layers ms-4 me-2">
				<i class="${fileIcon}"></i>
				<i class="${editIcon}" data-fa-transform="shrink-4 down-12 right-12"></i>
			</span>`
			let fileDeleteIconHtml =
			`<span class="fa-layers ms-4 me-2">
				<i class="${fileIcon}"></i>
				<i class="${trashCanIcon}" data-fa-transform="shrink-4 down-12 right-12"></i>
			</span>`
			let objectivesAddIconHtml =
			`<span class="fa-layers ms-4 me-2">
				<i class="${listCheckIcon}"></i>
				<i class="${circlePlusIcon}" data-fa-transform="shrink-4 down-12 right-12"></i>
			</span>`
			let glossaryAddIconHtml =
			`<span class="fa-layers ms-4 me-2">
				<i class="${listIcon}"></i>
				<i class="${circlePlusIcon}" data-fa-transform="shrink-4 down-12 right-12"></i>
			</span>`
			let activitiesAddIconHtml =
			`<span class="fa-layers ms-4 me-2">
				<i class="${checkSquareIcon}"></i>
				<i class="${circlePlusIcon}" data-fa-transform="shrink-4 down-12 right-12"></i>
			</span>`
			let testAddIconHtml =
			`<span class="fa-layers ms-4 me-2">
				<i class="${checkCircleIcon}"></i>
				<i class="${circlePlusIcon}" data-fa-transform="shrink-4 down-12 right-12"></i>
			</span>`
			let recommendMultimediaIconHtml = 
			`<span class="fa-layers ms-4 me-2">
				<i class="${photoVideoIcon}"></i>
				<i class="${searchIcon}" data-fa-transform="shrink-4 down-12 right-12"></i>
			</span>`
			let generateLessonsIconHtml =
			`<span class="fa-layers ms-4 me-2">
				<i class="${magicWandIcon}"></i>
				<i class="${folderIcon}" data-fa-transform="shrink-4 down-12 right-12"></i>
			</span>`
			let generateHeadingsIconHtml =
			`<span class="fa-layers ms-4 me-2">
				<i class="${magicWandIcon}"></i>
				<i class="${fileIcon}" data-fa-transform="shrink-4 down-12 right-12"></i>
			</span>`
			let generateImagesIconHtml =
			`<span class="fa-layers ms-4 me-2">
				<i class="${magicWandIcon}"></i>
				<i class="${imageIcon}" data-fa-transform="shrink-4 down-12 right-12"></i>
			</span>`
			let generateActivitiesIconHtml =
			`<span class="fa-layers ms-4 me-2">
				<i class="${magicWandIcon}"></i>
				<i class="${checkSquareIcon}" data-fa-transform="shrink-4 down-12 right-12"></i>
			</span>`
			let generateTestIconHtml =
			`<span class="fa-layers ms-4 me-2">
				<i class="${magicWandIcon}"></i>
				<i class="${checkCircleIcon}" data-fa-transform="shrink-4 down-12 right-12"></i>
			</span>`
			let translateIconHtml =
			`<span class="fa-layers ms-4 me-2">
				<i class="${magicWandIcon}"></i>
				<i class="${languageIcon}" data-fa-transform="shrink-4 down-12 right-12"></i>
			</span>`

			this.jsTree.defaults.contextmenu!.items = (node: any) => {

				let unitItems = {
					create: {
						label: circlePlusIconHtml + `<span>Crear</span>`,
						submenu: {
							createUnit: {
								label: folderAddIconHtml + '<span>Crear unidad</span>',
								action: () => {
									let position = +node.original.position + 1
									let parent = this.courseID
									let newNodeData = {
										'text': `Unidad de aprendizaje ${position + 1}: `,
										'type': 'unit',
									}

									jstree.jstree(true).create_node('#', newNodeData, position, (node: any) => {
										jstree.jstree(true).edit(node.id, undefined, (node: any, _status: any, cancelled: any) => {
											if (!cancelled) this.insertNode(node, position, parent)
											else this.jstreeUpdate()
										})
									})
								},
							},
							createLesson: {
								label: folderAddIconHtml + '<span>Crear lección</span>',
								action: () => {
									let id = node.id
									let insertPos = node.children.length
									let lessonNum = insertPos
									let hasObjectives = node.data.objectives
									let hasSummary = node.data.summary
									let hasGlossary = node.data.glossary
									if (hasObjectives) lessonNum -= 1
									if (hasSummary) {
										lessonNum -= 1
										insertPos -= 1
									}
									if (hasGlossary) {
										lessonNum -= 1
										insertPos -= 1
									}

									let newNodeData = {
										'text': `Lección ${lessonNum + 1}: `,
										'type': 'lesson',
									}
									let parent = +node.data.id

									jstree.jstree(true).create_node(id, newNodeData, insertPos, (node: any) => {
										jstree.jstree(true).edit(node.id, undefined, (node: any, _status: any, cancelled: any) => {
											if (!cancelled) this.insertNode(node, insertPos, parent)
											else this.jstreeUpdate()
										})
									})
								}
							},
							createObjectives: {
								label: objectivesAddIconHtml + '<span>Crear objetivos</span>',
								action: () => {
									let id = node.id
									let parent = +node.data.id
									let insertPos = 0

									let hasObjectives = node.data.objectives
									if (hasObjectives) {
										Swal.fire('Cuidado', 'Sólo puede haber un conjunto de objetivos por unidad.', 'warning')
										return
									}

									let newNodeData = {
										'text': 'Objetivos',
										'type': 'objectives'
									}

									jstree.jstree(true).create_node(id, newNodeData, insertPos, (node: any) => {
										this.insertNode(node, insertPos, parent)
									})
								},
							},
							createSummary: {
								label: fileAddIconHtml + '<span>Crear resumen</span>',
								action: () => {
									let id = node.id
									let insertPos = node.children.length
									let hasSummary = node.data.summary
									let hasGlossary = node.data.glossary

									if (hasSummary) {
										Swal.fire('Cuidado', 'Sólo puede haber un resumen por unidad.', 'warning')
										return
									}

									if (hasGlossary) insertPos -= 1

									let newNodeData = {
										'text': 'Resumen',
										'type': 'summary'
									}
									let parent = +node.data.id

									jstree.jstree(true).create_node(id, newNodeData, insertPos, (node: any) => {
										this.insertNode(node, insertPos, parent)
									})
								}
							},
							createGlossary: {
								label: glossaryAddIconHtml + '<span>Crear glosario</span>',
								action: () => {
									let id = node.id
									let hasGlossary = node.data.glossary
									if (hasGlossary) {
										Swal.fire('Cuidado', 'Sólo puede haber un glosario por unidad.', 'warning')
										return
									}

									let newNodeData = {
										'text': 'Glosario',
										'type': 'glossary'
									}
									let position = node.children.length
									let parent = +node.data.id

									jstree.jstree(true).create_node(id, newNodeData, 'last', (node: any) => {
										this.insertNode(node, position, parent)
									})
								}
							},
						}
					},
					unitRecommendMultimedia: {
						label: recommendMultimediaIconHtml + '<span>Recomendar multimedia</span>',
						submenu: {
							unitRecommendImages: {
								label: imageIconHtml + '<span>Imágenes</span>',
								action: () => {
									let unitHasLessons = node.data.lessons > 0
									if (!unitHasLessons) {
										Swal.fire('Ciudado', 'La unidad no tiene lecciones.', 'warning')
										return
									}

									let unit = +node.data.id
									console.log(unit)
									// this.unitRecommendMultimedia(unit, 'images')
								}
							},
							unitRecommendVideos: {
								label: videoIconHtml + '<span>Videos</span>',
								action: () => {
									let unitHasLessons = node.data.lessons > 0
									if (!unitHasLessons) {
										Swal.fire('Ciudado', 'La unidad no tiene lecciones.', 'warning')
										return
									}

									let unit = +node.data.id
									console.log(unit)
									// this.unitRecommendMultimedia(unit, 'videos')
								}
							},
							unitRecommendBoth: {
								label: photoVideoIconHtml + '<span>Ambos</span>',
								action: () => {
									let unitHasLessons = node.data.lessons > 0
									if (!unitHasLessons) {
										Swal.fire('Ciudado', 'La unidad no tiene lecciones.', 'warning')
										return
									}

									let unit = +node.data.id
									console.log(unit)
									// this.unitRecommendMultimedia(unit, 'both')
								}
							}
						}
					},
					ai: {
						label: magicWandIconHtml + '<span>IA</span>',
						submenu: {
							generateLessons: {
								label: generateLessonsIconHtml + '<span>Generar lecciones</span>',
								action: () => {
									let hasLessons = node.data.lessons > 0
									if (hasLessons) {
										Swal.fire('Cuidado', 'La unidad debe estar vacía de lecciones para poder generar lecciones nuevas.', 'warning')
										return
									}

									this.generateUnitID = +node.data.id
									this.generateUnitName = node.text

									let dialog = document.getElementById('generate-unit-dialog') as HTMLDialogElement
									dialog.showModal()
									dialog.scrollTo(0, 0)
								}
							},
							generateSummary: {
								label: fileAddIconHtml + '<span>Generar resumen</span>',
								action: () => {
									let hasSummary = node.data.summary

									if (hasSummary) {
										Swal.fire('Cuidado', 'Sólo puede haber un resumen por unidad.', 'warning')
										return
									}

									let unit = +node.data.id
									this.generateUnitSummaryAI(unit)
								}
							},
							generateGlossary: {
								label: glossaryAddIconHtml + '<span>Generar glosario</span>',
								action: () => {
									let hasGlossary = node.data.glossary

									if (hasGlossary) {
										Swal.fire('Cuidado', 'Sólo puede haber un glosario por unidad.', 'warning')
										return
									}

									let unit = +node.data.id
									this.generateUnitGlossaryAI(unit)
								}
							},
							translate: {
								label: translateIconHtml + '<span>Traducir</span>',
								submenu: {
									translateCa: {
										label: '<span class="ms-4 me-2"><i class="catalan me-2"></i></span><span>Catalá / Catalán</span>',
										action: () => {
											// console.log(node)
											let unit = +node.data.id
											this.translateUnitAI(unit, 'ca')
										}
									},
									translateGl: {
										label: '<span class="ms-4 me-2"><i class="galician me-2"></i></span><span>Galego / Gallego</span>',
										action: () => {
											// console.log(node)
											let unit = +node.data.id
											this.translateUnitAI(unit, 'gl')
										}
									},
									translateEn: {
										label: '<span class="ms-4 me-2"><i class="english me-2"></i></span><span>English / Inglés</span>',
										action: () => {
											// console.log(node)
											let unit = +node.data.id
											this.translateUnitAI(unit, 'en')
										}
									},
								},
							},
						},
					},
					moveUnit: {
						label: folderMoveIconHtml + '<span>Mover a otro curso</span>',
						action: () => {
							let unitId = +node.data.id
							let unitName = node.text
							this.zone.run(() => {
								this.showMoveUnit(unitId, unitName)
							})
						}
					},
					editUnit: {
						label: folderEditIconHtml + '<span>Editar</span>',
						action: () => {
							jstree.jstree(true).edit(node)
						}
					},
					emptyUnit: {
						label: folderDeleteIconHtml + '<span>Vaciar</span>',
						action: () => {
							let lessonsNum = jstree.jstree(true).get_node(node.parent).children.length
							if (lessonsNum == 0) {
								Swal.fire('Cuidado', 'No se puede vaciar esta unidad, ya está vacía.', 'warning')
								return
							}

							jstree.jstree(true).set_icon(node, 'fas fa-spinner fa-spin me-2')
							jstree.jstree(true).set_text(node, node.text + ' (Vaciando...)')
							this.emptyNode(node)
						}
					},
					deleteUnit: {
						label: folderDeleteIconHtml + '<span>Eliminar</span>',
						action: () => {
							let unitsNum = jstree.jstree(true).get_node(node.parent).children.length
							if (unitsNum == 1) {
								Swal.fire('Cuidado', 'No se puede eliminar esta unidad, es la última unidad.', 'warning')
								return
							}

							this.deleteNode(node)
						}
					}
				}

				let lessonItems = {
					newHeading: {
						label: fileAddIconHtml + '<span>Crear enunciado</span>',
						action: () => {
							let id = node.id
							let hasActivity = node.data.activities
							let hasTest = node.data.test

							let insertPos = node.children.length
							if (hasActivity) insertPos -= 1
							if (hasTest) insertPos -= 1

							let newNodeData = {
								'text': 'Nuevo enunciado',
								'type': 'heading',
							}
							let parent = +node.data.id

							jstree.jstree(true).create_node(id, newNodeData, insertPos, (node: any) => {
								jstree.jstree(true).edit(node.id, undefined, (node: any, _status: any, cancelled: any) => {
									if (!cancelled) this.insertNode(node, insertPos - 2, parent)
									else this.jstreeUpdate()
								})
							})
						}
					},
					newActivities: {
						label: activitiesAddIconHtml + '<span>Crear actividades</span>',
						action: () => {
							let id = node.id
							let hasTest = node.data.test

							let insertPos = node.children.length
							if (hasTest) insertPos -= 1

							let newNodeData = {
								'text': 'Actividades',
								'type': 'activity',
							}
							let parent = +node.data.id

							jstree.jstree(true).create_node(id, newNodeData, insertPos, (node: any) => {
								jstree.jstree(true).edit(node.id, undefined, (node: any, _status: any, cancelled: any) => {
									if (!cancelled) this.insertNode(node, insertPos, parent)
									else this.jstreeUpdate()
								})
							})
						}
					},
					newTest: {
						label: testAddIconHtml + '<span>Crear evaluación</span>',
						action: () => {
							let id = node.id
							let hasTest = node.data.test
							if (hasTest) {
								Swal.fire('Cuidado', 'Sólo puede haber una evaluación por lección.', 'warning')
								return
							}

							let insertPos = node.children.length
							let newNodeData = {
								'text': 'Evaluación',
								'type': 'test',
							}
							let parent = +node.data.id

							jstree.jstree(true).create_node(id, newNodeData, 'last', (node: any) => {
								jstree.jstree(true).edit(node.id, undefined, (node: any, _status: any, cancelled: any) => {
									if (!cancelled) this.insertNode(node, insertPos, parent)
									else this.jstreeUpdate()
								})
							})
						}
					},
					newCaseStudy: {
						label: fileAddIconHtml + '<span>Crear caso práctico</span>',
						submenu: {
							newCaseStudyRequired: {
								label: fileExclamationIconHtml + '<span>Obligatorio</span>',
								action: () => {
									let id = node.id
									let insertPos = node.children.length

									let hasActivity = node.data.activities
									let hasTest = node.data.test
									if (hasActivity) insertPos -= 1
									if (hasTest) insertPos -= 1

									let newNodeData = {
										'text': 'Caso Práctico Obligatorio',
										'type': 'case_study_required',
									}
									let parent = +node.data.id

									jstree.jstree(true).create_node(id, newNodeData, insertPos, (node: any) => {
										this.insertNode(node, insertPos, parent)
									})
								}
							},
							newCaseStudyOptional: {
								label: fileQuestionIconHtml + '<span>Opcional</span>',
								action: () => {
									let id = node.id
									let insertPos = node.children.length

									let hasActivity = node.data.activities
									let hasTest = node.data.test
									if (hasActivity) insertPos -= 1
									if (hasTest) insertPos -= 1

									let newNodeData = {
										'text': 'Caso Práctico Opcional',
										'type': 'case_study_optional',
									}
									let parent = +node.data.id

									jstree.jstree(true).create_node(id, newNodeData, insertPos, (node: any) => {
										this.insertNode(node, insertPos, parent)
									})
								}
							},
							newCaseStudyResolved: {
								label: fileCheckIconHtml + '<span>Resuelto</span>',
								action: () => {
									let id = node.id
									let insertPos = node.children.length

									let hasActivity = node.data.activities
									let hasTest = node.data.test
									if (hasActivity) insertPos -= 1
									if (hasTest) insertPos -= 1

									let newNodeData = {
										'text': 'Caso Práctico Resuelto',
										'type': 'case_study_resolved',
									}
									let parent = +node.data.id

									jstree.jstree(true).create_node(id, newNodeData, 'last', (node: any) => {
										this.insertNode(node, insertPos, parent)
									})
								}
							},
						},
					},
					newLesson: {
						label: folderAddIconHtml + '<span>Crear lección</span>',
						action: () => {
							let hasActivity = node.data.activities
							let hasTest = node.data.test
							let hasGlossary = node.data.glossary

							let position = +node.original.position + 1
							let insertPos = position
							if (hasActivity) insertPos -= 1
							if (hasTest) insertPos -= 1
							if (hasGlossary) insertPos -= 1

							let parent = +node.data.parent
							let newNodeData = {
								'text': `Lección ${position + 1}: `,
								'type': 'lesson',
							}

							jstree.jstree(true).create_node(node.parent, newNodeData, position, (node: any) => {
								jstree.jstree(true).edit(node.id, undefined, (node: any, _status: any, cancelled: any) => {
									if (!cancelled) this.insertNode(node, position, parent)
									else this.jstreeUpdate()
								})
							})
						}
					},
					lessonRecommendMultimedia: {
						label: recommendMultimediaIconHtml + '<span>Recomendar multimedia</span>',
						submenu: {
							lessonRecommendImages: {
								label: imageIconHtml + '<span>Imágenes</span>',
								action: () => {
									let lessonHasHeadings = node.data.headings > 0
									if (!lessonHasHeadings) {
										Swal.fire('Ciudado', 'La lección no tiene enunciados.', 'warning')
										return
									}

									let lesson = +node.data.id
									this.lessonRecommendMultimedia(lesson, 'images')
								}
							},
							lessonRecommendVideos: {
								label: videoIconHtml + '<span>Videos</span>',
								action: () => {
									let lessonHasHeadings = node.data.headings > 0
									if (!lessonHasHeadings) {
										Swal.fire('Ciudado', 'La lección no tiene enunciados.', 'warning')
										return
									}

									let lesson = +node.data.id
									this.lessonRecommendMultimedia(lesson, 'videos')
								}
							},
							lessonRecommendBoth: {
								label: photoVideoIconHtml + '<span>Ambos</span>',
								action: () => {
									let lessonHasHeadings = node.data.headings > 0
									if (!lessonHasHeadings) {
										Swal.fire('Ciudado', 'La lección no tiene enunciados.', 'warning')
										return
									}

									let lesson = +node.data.id
									this.lessonRecommendMultimedia(lesson, 'both')
								}
							}
						}
					},
					ai: {
						label: magicWandIconHtml + '<span>IA</span>',
						submenu: {
							generateLessonHeadings: {
								label: generateHeadingsIconHtml + '<span>Generar enunciados</span>',
								action: async () => {
									let generate = true
									let lessonHasHeadings = node.data.headings > 0
									if (lessonHasHeadings) {
										generate = await Swal.fire({
											title: '¿Seguro?',
											text: 'Al generar enunciados nuevos, se eliminarán los enunciados existentes. ¿Continuar?',
											icon: 'question',
											showCancelButton: true,
											cancelButtonText: 'Cancelar'
										}).then((result) => {
											// console.log(result)
											return result.isConfirmed
										})
									}

									if (!generate) return

									let lesson = +node.data.id
									this.generateLessonHeadingsAI(lesson)
								}
							},
							lessonSummarizeHeadings: {
								label: generateHeadingsIconHtml + '<span>Resumir enunciados</span>',
								action: async () => {
									let lessonHasHeadings = node.data.headings > 0
									if (!lessonHasHeadings) {
										Swal.fire('Cuidado', 'La lección debe tener enunciados para resumir.', 'warning')
										return
									}

									let lesson = +node.data.id
									this.lessonSummarizeHeadings(lesson)
								}
							},
							/*
							generateLessonHeadingImages: {
								label: generateImagesIconHtml + '<span>Generar imágenes para enunciados</span>',
								action: () => {
									let lessonHasHeadings = node.data.headings > 0
									if (!lessonHasHeadings) {
										Swal.fire('Ciudado', 'La lección no tiene enunciados.', 'warning')
										return
									}

									jstree.jstree(true).set_icon(node, 'fas fa-spinner fa-spin me-2')
									jstree.jstree(true).set_text(node, node.text + ' (Generando imágenes para enunciados...)')
									let lesson = +node.data.id
									this.generateLessonHeadingImagesAI(this.courseID, lesson)
								}
							},
							*/
							generateLessonCaseStudy: {
								label: generateHeadingsIconHtml + '<span>Generar caso práctico</span>',
								submenu: {
									generateLessonCaseStudyRequired: {
										label: generateHeadingsIconHtml + '<span>Obligatorio</span>',
										action: () => {
											let lesson = +node.data.id
											let type = 'case_study_required'
											this.generateLessonCaseStudyAI(lesson, type)
										}
									},
									generateLessonCaseStudyOptional: {
										label: generateHeadingsIconHtml + '<span>Opcional</span>',
										action: () => {
											let lesson = +node.data.id
											let type = 'case_study_optional'
											this.generateLessonCaseStudyAI(lesson, type)
										}
									},
									generateLessonCaseStudyResolved: {
										label: generateHeadingsIconHtml + '<span>Resuelto</span>',
										action: () => {
											let lesson = +node.data.id
											let type = 'case_study_resolved'
											this.generateLessonCaseStudyAI(lesson, type)
										}
									},
								}
							},
							generateActivities: {
								label: generateActivitiesIconHtml + '<span>Generar actividades</span>',
								action: () => {
									// console.log(node)
									let lessonHasHeadings = node.data.headings > 0
									let lessonHasActivity = node.data.activities
									if (!lessonHasHeadings) {
										Swal.fire('Cuidado', 'La lección debe tener enunciados para generar actividades.', 'warning')
										return
									}
									if (lessonHasActivity) {
										Swal.fire('Cuidado', 'La lección ya tiene actividades. Para generar actividades nuevas, debe eliminar las existentes.', 'warning')
										return
									}

									let lesson = +node.data.id
									this.generateActivitiesAI(lesson)
								}
							},
							generateTest: {
								label: generateTestIconHtml + '<span>Generar evaluación</span>',
								action: () => {
									// console.log(node)
									let lessonHasHeadings = node.data.headings > 0
									let lessonHasTest = node.data.test
									if (!lessonHasHeadings) {
										Swal.fire('Cuidado', 'La lección debe tener enunciados para generar una evaluación.', 'warning')
										return
									}
									if (lessonHasTest) {
										Swal.fire('Cuidado', 'La lección ya tiene evaluación. Para generar una evaluación nueva, debe eliminar la existente.', 'warning')
										return
									}

									let lesson = +node.data.id
									this.generateTestAI(lesson)
								}
							},
							translate: {
								label: translateIconHtml + '<span>Traducir</span>',
								submenu: {
									translateCa: {
										label: '<span class="ms-4 me-2"><i class="catalan me-2"></i></span><span>Catalá / Catalán</span>',
										action: () => {
											// console.log(node)
											let lesson = +node.data.id
											this.translateLessonAI(lesson, 'ca')
										}
									},
									translateGl: {
										label: '<span class="ms-4 me-2"><i class="galician me-2"></i></span><span>Galego / Gallego</span>',
										action: () => {
											// console.log(node)
											let lesson = +node.data.id
											this.translateLessonAI(lesson, 'gl')
										}
									},
									translateEn: {
										label: '<span class="ms-4 me-2"><i class="english me-2"></i></span><span>English / Inglés</span>',
										action: () => {
											// console.log(node)
											let lesson = +node.data.id
											this.translateLessonAI(lesson, 'en')
										}
									},
								},
							},
						},
					},
					editLesson: {
						label: folderEditIconHtml + '<span>Editar</span>',
						action: () => {
							let text = node.text.replaceAll(/<\/?[^>]+(>|$)/g, '').trim()
							jstree.jstree(true).edit(node, text)
						}
					},
					deleteLesson: {
						label: folderDeleteIconHtml + '<span>Eliminar</span>',
						action: () => {
							this.deleteNode(node)
						}
					}
				}

				let headingItems = {
					newHeading: {
						label: fileAddIconHtml + '<span>Crear enunciado</span>',
						action: () => {
							let newNodeData = {
								'text': 'Nuevo enunciado',
								'type': 'heading',
							}
							let position = +node.original.position + 3
							let parent = +node.data.parent

							jstree.jstree(true).create_node(node.parent, newNodeData, position, (node: any) => {
								jstree.jstree(true).edit(node.id, undefined, (node: any, _status: any, cancelled: any) => {
									if (!cancelled) this.insertNode(node, position - 2, parent)
									else this.jstreeUpdate()
								})
							})
						}
					},
					changeToCaseStudy: {
						label: fileEditIconHtml + '<span>Cambiar a Caso Práctico</span>',
						submenu: {
							changeToCaseStudyRequired: {
								label: fileExclamationIconHtml + '<span>Obligatorio</span>',
								action: () => {
									node.type = 'case_study_required'
									this.editNode(node)
								}
							},
							changeToCaseStudyOptional: {
								label: fileQuestionIconHtml + '<span>Opcional</span>',
								action: () => {
									node.type = 'case_study_optional'
									this.editNode(node)
								}
							},
							changeToCaseStudyResolved: {
								label: fileCheckIconHtml + '<span>Resuelto</span>',
								action: () => {
									node.type = 'case_study_resolved'
									this.editNode(node)
								}
							},
						}
					},
					ai: {
						label: magicWandIconHtml + '<span>IA</span>',
						submenu: {
							headingSummarizeContent: {
								label: magicWandIconHtml + '<span>Resumir enunciado</span>',
								action: () => {
									this.headingSummarizeContent(node.data.id)
								}
							},
						}
					},
					editHeading: {
						label: fileEditIconHtml + '<span>Editar</span>',
						action: () => {
							let text = node.text.replaceAll(/<\/?[^>]+(>|$)/g, '').trim()
							jstree.jstree(true).edit(node, text)
						}
					},
					deleteHeading: {
						label: fileDeleteIconHtml + '<span>Eliminar</span>',
						action: () => {
							this.deleteNode(node)
						}
					}
				}

				let caseStudyItems = {
					changeType: {
						label: fileEditIconHtml + '<span>Cambiar tipo</span>',
						submenu: {
							changeToHeading: {
								label: fileIconHtml + '<span>Cambiar a enunciado</span>',
								action: () => {
									// console.log(node)
									node.type = 'heading'
									this.editNode(node)
									this.jstreeUpdate()
								}
							},
							changeTypeRequired: {
								label: fileExclamationIconHtml + '<span>Cambiar a Obligatorio</span>',
								action: () => {
									// console.log(node)
									node.type = 'case_study_required'
									node.text = 'Caso Práctico Obligatorio: ' + node.text
									this.editNode(node)
									this.jstreeUpdate()
								}
							},
							changeTypeOptional: {
								label: fileQuestionIconHtml + '<span>Cambiar a Opcional</span>',
								action: () => {
									// console.log(node)
									node.type = 'case_study_optional'
									node.text = 'Caso Práctico Opcional: ' + node.text
									this.editNode(node)
									this.jstreeUpdate()
								}
							},
							changeTypeResolved: {
								label: fileCheckIconHtml + '<span>Cambiar a Resuelto</span>',
								action: () => {
									// console.log(node)
									node.type = 'case_study_resolved'
									node.text = 'Caso Práctico Resuelto: ' + node.text
									this.editNode(node)
									this.jstreeUpdate()
								}
							},
						}
					},
					editNode: {
						label: fileEditIconHtml + '<span>Editar</span>',
						action: () => {
							jstree.jstree(true).edit(node)
						}
					},
					deleteNode: {
						label: fileDeleteIconHtml + '<span>Eliminar</span>',
						action: () => {
							this.deleteNode(node)
						}
					}
				}

				let nodeItems = {
					editNode: {
						label: editIconHtml + '<span>Editar</span>',
						action: () => {
							jstree.jstree(true).edit(node)
						}
					},
					deleteNode: {
						label: trashCanIconHtml + '<span>Eliminar</span>',
						action: () => {
							this.deleteNode(node)
						}
					}
				}

				let noContextMenuNodes = ['multimedia', 'tables', 'files']
				let items: any = {}
				let nodeType = node.type

				if (nodeType == 'unit') items = unitItems
				else if (nodeType == 'lesson') items = lessonItems
				else if (nodeType == 'heading') items = headingItems
				else if (nodeType.includes('case_study')) {
					items = caseStudyItems
					if (nodeType.includes('required')) delete items.changeType.submenu.changeTypeRequired
					else if (nodeType.includes('optional')) delete items.changeType.submenu.changeTypeOptional
					else if (nodeType.includes('resolved')) delete items.changeType.submenu.changeTypeResolved
				}
				else if (noContextMenuNodes.includes(nodeType)) items = {}
				else {
					items = nodeItems
					if (this.treeNonRenameTypes.includes(nodeType)) delete items.editNode
				}

				if (items.ai !== undefined) {
					if (items.ai.submenu.translate != undefined) {
						if (!this.courseMultitransl) delete items.ai.submenu.translate
						else {
							if (!this.courseTranslations.includes('ca')) delete items.ai.submenu.translate.submenu.translateCa
							if (!this.courseTranslations.includes('gl')) delete items.ai.submenu.translate.submenu.translateGl
							if (!this.courseTranslations.includes('en')) delete items.ai.submenu.translate.submenu.translateEn
						}
						if (!this.userAI) delete items.ai
					}
				}

				return items
			}

			jstree.jstree({
				'core': {
					'check_callback': (operation: any, node: any, _node_parent: any, _node_position: any, more: any) => {
						// Desactivar mover nodos para los nodos estáticos (Ver multimedia / tablas)
						if (operation == 'move_node') {
							let dnd = more.dnd
							let nodeTypeOnTop = more.ref !== undefined ? more.ref.type : undefined
							// console.log(dnd)
							// console.log(nodeTypeOnTop)
							if (dnd && (this.treeNonDragTypes.includes(node.type) || this.treeNonDragTypes.includes(nodeTypeOnTop))) return false
						}

						// Desactivar renombrar para ciertos nodos
						if (operation == 'edit') {
							if (this.treeNonRenameTypes.includes(node.type)) return false
						}

						// Activar todos los demás eventos
						return true
					},
					'keyboard': {
						'f2': false,
					},
					'multiple': false,
					'strings': {
						'Loading ...': 'Cargando ...'
					},
					'themes': {
						'name': 'default',
					},
					'data': {
						'dataType': 'json',
						'url': this.treeDataUrl,
						'data': (node: any) => {
							let type = node.type
							let data = {}
							if (type == undefined || type == '#') {
								data = {
									'course': this.courseID,
									'multitransl': this.courseMultitransl,
									'transl': this.courseCurrentTransl,
									'tree': true,
								}
							} else {
								let id = +node.data.id
								if (type == 'unit') {
									data = {
										'unit': id,
										'multitransl': this.courseMultitransl,
										'transl': this.courseCurrentTransl,
										'tree': true,
									}
								} else if (type == 'lesson') {
									data = {
										'lesson': id,
										'multitransl': this.courseMultitransl,
										'transl': this.courseCurrentTransl,
										'tree': true,
									}
								}
							}

							return data
						}

					},
				},
				'contextmenu': {
					'select_node': true,
					'show_at_node': false,
				},
				'dnd': {
					'copy': false,
					'drag_selection': false,
					'large_drop_target': true,
					'large_drag_target': true,
					'open_timeout': 1500,
				},
				// 'search': {},
				'state': {
					'key': `jstree_course_${this.courseID}`,
					'preserve_loaded': true,
				},
				'types': {
					'#': {
						'max_depth': 3,
						'valid_children': [
							'unit',
							'unit_create',
						],
					},
					'unit': {
						'icon': folderIcon,
						'max_depth': 2,
						'valid_children': [
							'lesson',
							'summary',
							'glossary',
							'objectives'
						],
					},
					'unit_create': {
						icon: folderAddIcon,
						valid_children: false,
					},
					'lesson': {
						'icon': folderIcon,
						'max_depth': 1,
						'valid_children': [
							'heading',
							'case_study_required',
							'case_study_optional',
							'case_study_resolved',
							'multimedia',
							'tables',
							'activity',
							'test'
						],
					},
					'multimedia': {
						'icon': photoVideoIcon,
						'valid_children': false,
					},
					'files': {
						'icon': archiveIcon,
						'valid_children': false,
					},
					'tables': {
						'icon': tableIcon,
						'valid_children': false,
					},
					'heading': {
						'icon': fileIcon,
						'valid_children': false,
					},
					'summary': {
						'icon': fileIcon,
						'valid_children': false,
					},
					'case_study_required': {
						'icon': fileExclamationIcon,
						'valid_children': false,
					},
					'case_study_optional': {
						'icon': fileQuestionIcon,
						'valid_children': false,
					},
					'case_study_resolved': {
						'icon': fileCheckIcon,
						'valid_children': false,
					},
					'activity': {
						'icon': checkSquareIcon,
						'valid_children': false,
					},
					'test': {
						'icon': checkCircleIcon,
						'valid_children': false,
					},
					'glossary': {
						'icon': listIcon,
						'valid_children': false,
					},
					'objectives': {
						'icon': listCheckIcon,
						'valid_children': false,
					},
				},
				'plugins': ['contextmenu', 'dnd', 'search', 'state', 'types', 'wholerow']
			})

			jstree.on('rename_node.jstree', (_e: any, data: any) => {
				// console.log(data)
				let node = data.node
				let id = node.id
				let newText = data.text.trim()
				let oldText = data.old.trim()
				let rename = newText != oldText && id != "j1_1"

				if (rename) this.editNode(node)
				else this.jstreeUpdate()
			})

			jstree.on('changed.jstree', (_e: any, data: any) => {
				let node = data.node
				// console.log(node)
				if (node === undefined) return

				let type = node.type
				let id = +node.data.id
				// console.log(type)
				// console.log(id)

				if (type === 'unit') {
					this.zone.run(() => {
						this.showUnitInfo(id)
					})
				} else if (type === 'lesson') {
					this.zone.run(() => {
						this.showLessonInfo(id)
					})
				} else if (type === 'heading' || type.includes('case_study')) {
					this.zone.run(() => {
						this.showHeading(id, type)
					})
				} else if (type === 'multimedia') {
					this.zone.run(() => {
						this.showMultimedia(id)
					})
				} else if (type === 'files') {
					this.zone.run(() => {
						this.showFiles(id)
					})
				} else if (type === 'tables') {
					this.zone.run(() => {
						this.showTables(id)
					})
				} else if (type === 'activity' || type === 'test') {
					this.zone.run(() => {
						this.showActivityTest(id, type)
					})
				} else if (type === 'glossary') {
					this.zone.run(() => {
						this.showGlossary(id)
					})
				} else if (type === 'summary') {
					this.zone.run(() => {
						this.showSummary(id)
					})
				} else if (type === 'objectives') {
					this.zone.run(() => {
						this.showObjectives(id)
					})
				} else if (type === 'unit_create') {
					jstree.jstree(true).deselect_node(node)
					let newUnitNum = node.original.position + 1
					this.generateUnitID = 0
					this.generateUnitName = `Unidad de aprendizaje ${newUnitNum}: `
					let dialog = document.getElementById('generate-unit-dialog') as HTMLDialogElement
					dialog.showModal()
				} else {
					this.hideAll()
				}
				return
			})

			jstree.on('move_node.jstree', (_e: any, data: any) => {
				let nodes: any[] = []

				let oldParentNodeId = data.old_parent
				let newParentNodeId = data.parent
				let oldParentNode = jstree.jstree(true).get_node(oldParentNodeId)
				let oldParentNodeType = oldParentNode.type
				oldParentNode.children.forEach((nodeId: string, i: number) => {
					let node = jstree.jstree(true).get_node(nodeId)
					let nodeType = node.type
					if (this.treeNonDragTypes.includes(nodeType)) return
					
					nodeId = node.data.id
					let nodeParentType = oldParentNodeType
					let nodePosition = i
					if (nodeParentType == 'lesson') nodePosition -= 2
					
					let nodeParentId = 0
					if (nodeParentType == '#') {
						nodeParentId = this.courseID
						nodeParentType = 'course'
					} else {
						nodeParentId = oldParentNode.data.id
					}

					nodes.push({
						'id': nodeId,
						'type': nodeType,
						'position': nodePosition,
						'parent': {
							'id': nodeParentId,
							'type': nodeParentType
						}
					})
				})


				if (oldParentNodeId != newParentNodeId) {
					let newParentNode = jstree.jstree(true).get_node(newParentNodeId)
					let newParentNodeType = newParentNode.type
					newParentNode.children.forEach((nodeId: string, i: number) => {
						let node = jstree.jstree(true).get_node(nodeId)
						let nodeType = node.type
						if (this.treeNonDragTypes.includes(nodeType)) return

						nodeId = node.data.id
						let nodeParentType = newParentNodeType
						let nodePosition = i
						if (nodeParentType == 'lesson') nodePosition -= 2

						let nodeParentId = 0
						if (nodeParentType == '#') {
							nodeParentId = this.courseID
							nodeParentType = 'course'
						} else {
							nodeParentId = newParentNode.data.id
						}

						nodes.push({
							'id': nodeId,
							'type': nodeType,
							'position': nodePosition,
							'parent': {
								'id': nodeParentId,
								'type': nodeParentType
							}
						})
					})
				}

				this.updateNodePositions(nodes)
			})

			jstree.on('before_open.jstree', (_e: any, data: any) => {
				data.instance.set_icon(data.node, folderOpenIcon)
			})

			jstree.on('after_close.jstree', (_e: any, data: any) => {
				data.instance.set_icon(data.node, folderIcon)
			})
		})
	}

	jstreeUpdate() {
		$(() => {
			let jstree: any = $('#jstree')
			jstree.jstree(true).settings!.core.data.url = this.treeDataUrl
			jstree.jstree(true).refresh(true)
		})
	}

	jstreeLoadNode(node: any) {
		console.log('Loading node...')
		console.log(node)
		$(() => {
			let jstree: any = $('#jstree')
			jstree.jstree(true).load_node(node)
		})
	}

	jstreeOpenAll() {
		$(() => {
			let jstree: any = $('#jstree')
			jstree.jstree(true).open_all()
		})
	}

	jstreeCloseAll() {
		$(() => {
			let jstree: any = $('#jstree')
			jstree.jstree(true).close_all()
		})
	}

	changeTranslation() {
		this.courseNameView = this.courseName[this.courseCurrentTransl]
		this.jstreeUpdate()
	}

	hideAll() {
		this.unitInfo = false
		this.lessonInfo = false
		this.heading = false
		this.multimedia = false
		this.files = false
		this.tables = false
		this.glossary = false
		this.summary = false
		this.activityTest = false
		this.objectives = false
		this.coursePreview = false
		this.courseExport = false
		this.courseDuration = false
		this.report = false
		this.moveUnit = false
		this.checkLinks = false
		this.nodesTextSearch = false
		this.multimediaReport = false
		this.courseLock = false
		this.generateQuestionsMoodle = false
	}

	openCourseForm() {
		this.courseFormShow = true
		let dialog = document.getElementById('course-form-dialog') as HTMLDialogElement
		dialog.showModal()
		dialog.scrollTo(0, 0)
	}

	closeCourseForm() {
		this.courseFormShow = false
		let dialog = document.getElementById('course-form-dialog') as HTMLDialogElement
		dialog.close()
	}

	showUnitInfo(unit: number) {
		this.unitID = unit
		this.hideAll()
		this.unitInfo = true
	}

	showLessonInfo(lesson: number) {
		this.lessonID = lesson
		this.hideAll()
		this.lessonInfo = true
	}

	showHeading(heading: number, type: string) {
		this.headingID = heading
		this.headingType = type
		this.hideAll()
		this.heading = true
	}

	showSummary(summary: number) {
		this.summaryID = summary
		this.hideAll()
		this.summary = true
	}

	showMultimedia(lesson: number) {
		this.lessonID = lesson
		this.hideAll()
		this.multimedia = true
	}

	showFiles(lesson: number) {
		this.lessonID = lesson
		this.hideAll()
		this.files = true
	}

	showTables(lesson: number) {
		this.lessonID = lesson
		this.hideAll()
		this.tables = true
	}

	showActivityTest(activityTest: number, type: string) {
		// console.log(activityTest)
		// console.log(type)
		this.activityTestID = activityTest
		this.activityTestType = type
		this.hideAll()
		this.activityTest = true
	}

	showEdit(event: MouseEvent) {
		let span = event.currentTarget as HTMLSpanElement
		let edit = span.nextElementSibling as HTMLElement
		this.renderer.addClass(span, 'd-none')
		this.renderer.removeClass(edit, 'd-none')
		edit.focus()
	}

	hideEdit(event: Event) {
		let edit = event.currentTarget as HTMLElement
		let span = edit.previousElementSibling as HTMLElement
		this.renderer.addClass(edit, 'd-none')
		this.renderer.removeClass(span, 'd-none')
	}

	showGlossary(glossary: number) {
		this.glossaryID = glossary
		this.hideAll()
		this.glossary = true
	}

	showObjectives(objectives: number) {
		this.objectivesID = objectives
		this.hideAll()
		this.objectives = true
	}

	showCoursePreview(type: 'desktop' | 'mobile', language: 'es' | 'en' | 'cn' = 'es') {
		this.hideAll()
		this.coursePreview = true
		this.courseExportType = type
		this.courseExportLanguage = language
	}

	showCourseExport(type: 'desktop' | 'mobile' | 'pdf', language: 'es' | 'en' | 'cn' = 'es') {
		this.hideAll()
		this.courseExport = true
		this.courseExportType = type
		this.courseExportLanguage = language
	}

	cancelCourseExport() {
		this.hideAll()
		this.courseExport = false
	}

	showCourseBackup() {

	}

	cancelCourseBackup() {

	}

	showCourseDuration() {
		this.hideAll()
		this.courseDuration = true
	}

	cancelCourseDuration() {
		this.hideAll()
		this.courseDuration = false
	}

	showReport(type = '') {
		this.hideAll()
		this.report = true
		this.reportType = type
	}

	cancelReport() {
		this.hideAll()
		this.report = false
	}

	showMoveUnit(unitId: number, unitName: string) {
		this.hideAll()
		this.moveUnit = true
		this.moveUnitId = unitId
		this.moveUnitName = unitName
	}

	cancelMoveUnit() {
		this.hideAll()
		this.moveUnit = false
		this.moveUnitId = 0
		this.moveUnitName = ''
	}

	showCheckLinks(course: number) {
		this.hideAll()
		this.checkLinks = true
		this.checkLinksCourseId = course
	}

	cancelCheckLinks() {
		this.checkLinks = false
	}

	showNodesTextSearch(course: number) {
		this.hideAll()
		this.nodesTextSearch = true
		this.nodesTextSearchCourseId = course
	}

	cancelNodesTextSearch() {
		this.nodesTextSearch = false
	}

	showMultimediaReport(course: number) {
		this.hideAll()
		this.multimediaReport = true
		this.multimediaReportCourseId = course
	}

	cancelMultimediaReport() {
		this.nodesTextSearch = false
	}

	showGenerateQuestionsMoodle(course: number) {
		this.hideAll()
		this.generateQuestionsMoodle = true
		this.generateQuestionsMoodleCourseId = course
	}

	cancelGenerateQuestionsMoodle() {
		this.generateQuestionsMoodle = false
	}

	showCourseLock() {
		this.hideAll()
		this.courseLock = true
	}

	requestUnlock() {
		Swal.fire({
			title: '¿Seguro?',
			text: '¿Estás seguro que quieres enviar una solicitud de permiso para editar el curso?',
			icon: 'question',
			showCancelButton: true,
			cancelButtonText: 'Cancelar'
		}).then((result) => {
			// console.log(result)
			if (!result.isConfirmed) return

			this.courseUnlockRequestSub = this.dataService.courseUnlockRequest(this.courseID)
			.subscribe({
				next: (data) => {
					console.log(data)
					Swal.fire('Listo', 'Se ha enviado la solicitud.', 'success')
				},
				error: (e) => {
					console.log(e)
				},
			})
		})
	}

	headingSummarizeContent(heading: number) {
		Swal.fire({
			title: 'Resumir enunciado',
			html: "<p>Resumiendo enunciado...</p>",
			timer: 2000,
			showConfirmButton: false,
			allowEscapeKey: false,
			allowOutsideClick: false,
			didOpen: () => {
				Swal.showLoading()
				Swal.stopTimer()
				let htmlContainer = Swal.getHtmlContainer()!

				this.headingSummarizeContentAISub = this.dataService.headingSummarizeContentAI(heading)
				.subscribe({
					next: (result) => {
						console.log(result)
						if (result) {
							htmlContainer.innerHTML = "<p class='text-success'><i class='fas fa-check'></i><span>¡Enunciado resumido!</span></p>"
							Swal.hideLoading()
							Swal.resumeTimer()
						}
					},
					error: (e) => {
						console.log(e)

						// htmlContainer.innerHTML = "<p class='text-danger'><i class='fas fa-times'></i><span>Error</span></p>"
						// Swal.hideLoading()
						// Swal.resumeTimer()

						Swal.fire({
							title: 'Error',
							html: '' + e.error.message + '<br>¿Quieres intentarlo de nuevo?',
							icon: 'error',
							showCancelButton: true,
							cancelButtonText: 'Cancelar'
						}).then((result) => {
							// console.log(result)
							if (result.isConfirmed) this.headingSummarizeContent(heading)
							else this.jstreeUpdate()
						})
					},
				})
			},
		}).then((result) => {
			console.log(result)
			this.jstreeUpdate()
			// this.hideAll()
			this.showHeading(heading, 'heading')
		})
	}

	lessonSummarizeHeadings(lesson: number) {
		Swal.fire({
			title: 'Resumir enunciados',
			html: "<p>Resumiendo enunciados de la lección...</p>",
			timer: 2000,
			showConfirmButton: false,
			allowEscapeKey: false,
			allowOutsideClick: false,
			didOpen: () => {
				Swal.showLoading()
				Swal.stopTimer()
				let htmlContainer = Swal.getHtmlContainer()!

				this.lessonSummarizeHeadingsAISub = this.dataService.lessonSummarizeHeadingsAI(lesson)
				.subscribe({
					next: (result) => {
						console.log(result)
						if (result) {
							htmlContainer.innerHTML = "<p class='text-success'><i class='fas fa-check'></i><span>¡Enunciados de la lección resumidos!</span></p>"
							Swal.hideLoading()
							Swal.resumeTimer()
						}
					},
					error: (e) => {
						console.log(e)

						// htmlContainer.innerHTML = "<p class='text-danger'><i class='fas fa-times'></i><span>Error</span></p>"
						// Swal.hideLoading()
						// Swal.resumeTimer()

						Swal.fire({
							title: 'Error',
							html: '' + e.error.message + '<br>¿Quieres intentarlo de nuevo?',
							icon: 'error',
							showCancelButton: true,
							cancelButtonText: 'Cancelar'
						}).then((result) => {
							// console.log(result)
							if (result.isConfirmed) this.lessonSummarizeHeadings(lesson)
							else this.jstreeUpdate()
						})
					},
				})
			},
		}).then((result) => {
			console.log(result)
			this.jstreeUpdate()
		})
	}

	lessonRecommendMultimedia(lesson: number, type: 'images' | 'videos' | 'both') {
		let searchingMessage = "Buscando multimedia..."
		let resultMessage = "¡Se ha encontrado multimedia!"
		if (type == 'images') {
			searchingMessage = "Buscando imágenes..."
			resultMessage = "¡Se han encontrado imágenes!"
		}
		else if (type == 'videos') {
			searchingMessage = "Buscando videos..."
			resultMessage = "¡Se han encontrado videos!"
		}

		Swal.fire({
			title: 'Recomendar multimedia para lección',
			html: `<p>${searchingMessage}</p>`,
			timer: 2000,
			showConfirmButton: false,
			allowEscapeKey: false,
			allowOutsideClick: false,
			didOpen: () => {
				Swal.showLoading()
				Swal.stopTimer()
				let htmlContainer = Swal.getHtmlContainer()!

				this.lessonRecommendMultimediaSub = this.dataService.lessonRecommendMultimedia(lesson, type)
				.subscribe({
					next: (data) => {
						let result = data.result
						let message = data.message
						if (result) {
							htmlContainer.innerHTML = `<p class='text-success'><i class='fas fa-check'></i><span>${resultMessage}</span></p>`
							Swal.hideLoading()
							Swal.resumeTimer()
						} else {
							htmlContainer.innerHTML = `<p class='text-danger'><i class='fas fa-times'></i><span>Error: ${message}</span></p>`
							Swal.hideLoading()
							Swal.resumeTimer()
						}
					},
					error: (e) => {
						console.log(e)

						// htmlContainer.innerHTML = "<p class='text-danger'><i class='fas fa-times'></i><span>Error</span></p>"
						// Swal.hideLoading()
						// Swal.resumeTimer()

						Swal.fire({
							title: 'Error',
							html: '' + e.error.message + '<br>¿Quieres intentarlo de nuevo?',
							icon: 'error',
							showCancelButton: true,
							cancelButtonText: 'Cancelar'
						}).then((result) => {
							// console.log(result)
							if (result.isConfirmed) this.lessonRecommendMultimedia(lesson, type)
							else this.jstreeUpdate()
						})
					},
				})
			},
		}).then((result) => {
			console.log(result)
			this.jstreeUpdate()
		})
	}

	generateLessonHeadingsAI(lesson: number) {
		Swal.fire({
			title: 'Generar enunciados',
			html: "<p>Generando enunciados...</p>",
			timer: 2000,
			showConfirmButton: false,
			allowEscapeKey: false,
			allowOutsideClick: false,
			didOpen: () => {
				Swal.showLoading()
				Swal.stopTimer()
				let htmlContainer = Swal.getHtmlContainer()!

				this.generateLessonHeadingsAISub = this.dataService.generateLessonHeadingsAI(lesson)
				.subscribe({
					next: (result) => {
						console.log(result)
						if (result) {
							htmlContainer.innerHTML = "<p class='text-success'><i class='fas fa-check'></i><span>¡Enunciados generados!</span></p>"
							Swal.hideLoading()
							Swal.resumeTimer()
						}
					},
					error: (e) => {
						console.log(e)

						// htmlContainer.innerHTML = "<p class='text-danger'><i class='fas fa-times'></i><span>Error</span></p>"
						// Swal.hideLoading()
						// Swal.resumeTimer()

						Swal.fire({
							title: 'Error',
							html: '' + e.error.message + '<br>¿Quieres intentarlo de nuevo?',
							icon: 'error',
							showCancelButton: true,
							cancelButtonText: 'Cancelar'
						}).then((result) => {
							// console.log(result)
							if (result.isConfirmed) this.generateLessonHeadingsAI(lesson)
							else this.jstreeUpdate()
						})
					},
				})
			},
		}).then((result) => {
			console.log(result)
			this.jstreeUpdate()
		})
	}

	generateLessonCaseStudyAI(lesson: number, type: string) {
		Swal.fire({
			title: "Generar caso práctico",
			html: "<p>Generando...</p>",
			timer: 2000,
			showConfirmButton: false,
			allowEscapeKey: false,
			allowOutsideClick: false,
			didOpen: () => {
				Swal.showLoading()
				Swal.stopTimer()
				let htmlContainer = Swal.getHtmlContainer()!

				this.dataService.generateLessonCaseStudyAI(lesson, type)
				.subscribe({
					next: (data) => {
						console.log(data)
						htmlContainer.innerHTML = "<p class='text-success'><i class='fas fa-check'></i><span>¡Generado!</span></p>"
						Swal.hideLoading()
						Swal.resumeTimer()
					},
					error: (e) => {
						console.log(e)
						htmlContainer.innerHTML = "<p class='text-danger'><i class='fas fa-times'></i><span>Error</span></p>"
						Swal.hideLoading()
						Swal.resumeTimer()
					}
				})
			},
		}).then((result) => {
			console.log(result)
			this.jstreeUpdate()
		})
	}

	generateLessonHeadingImagesAI(course: number, lesson: number) {
		let command = 'lesson_generate_heading_images'
		let data = {
			'course_id': course,
			'lesson_id': lesson,
		}

		Swal.fire({
			title: "Generación de imágenes por lección",
			html: "<p id='job-message'>Empezando...</p><p id='job-progress'>Progreso: 0%</p>",
			timer: 2000,
			showConfirmButton: false,
			allowEscapeKey: false,
			allowOutsideClick: false,
			didOpen: () => {
				Swal.showLoading()
				Swal.stopTimer()

				const popup = Swal.getPopup()!
				const popupProgress = popup.querySelector("p#job-progress")
				const popupMessage = popup.querySelector("p#job-message")

				this.jobAddSub = this.dataService.jobAdd(command, data)
				.subscribe({
					next: (jobId) => {
						console.log(jobId)

						let interval = setInterval(() => {
							this.jobStatusSub = this.dataService.jobStatus(jobId)
							.subscribe({
								next: (data) => {
									console.log(data)
									let status = data.status
									let message = data.message
									let progress = data.progress

									popupMessage!.textContent = message
									popupProgress!.textContent = `Progreso: ${progress}%`

									if (status == 'completed') {
										clearInterval(interval)
										Swal.hideLoading()
										Swal.resumeTimer()
										// this.jstreeUpdate()
									}
								},
								error: (e) => {
									console.log(e)
									clearInterval(interval)
									// this.jstreeUpdate()
									Swal.hideLoading()
									Swal.resumeTimer()
								}
							})
						}, 1000)
					},
					error: (e) => {
						console.log(e)
					}
				})
			},
		}).then((result) => {
			console.log(result)
			this.jstreeUpdate()
		})
	}

	generateActivitiesAI(lesson: number) {
		Swal.fire({
			title: 'Generar actividades',
			html: "<p>Generando actividades...</p>",
			timer: 2000,
			showConfirmButton: false,
			allowEscapeKey: false,
			allowOutsideClick: false,
			didOpen: () => {
				Swal.showLoading()
				Swal.stopTimer()
				let htmlContainer = Swal.getHtmlContainer()!

				this.generateActivitiesAISub = this.dataService.generateActivitiesAI(lesson)
				.subscribe({
					next: (result) => {
						console.log(result)
						if (result) {
							htmlContainer.innerHTML = "<p class='text-success'><i class='fas fa-check'></i><span>¡Actividades generadas!</span></p>"
							Swal.hideLoading()
							Swal.resumeTimer()
						}
					},
					error: (e) => {
						console.log(e)

						// htmlContainer.innerHTML = "<p class='text-danger'><i class='fas fa-times'></i><span>Error</span></p>"
						// Swal.hideLoading()
						// Swal.resumeTimer()
		
						Swal.fire({
							title: 'Error',
							html: '' + e.error.message + '<br>¿Quieres intentarlo de nuevo?',
							icon: 'error',
							showCancelButton: true,
							cancelButtonText: 'Cancelar'
						}).then((result) => {
							// console.log(result)
							if (result.isConfirmed) this.generateActivitiesAI(lesson)
							else this.jstreeUpdate()
						})
					},
				})
			}
		}).then((result) => {
			console.log(result)
			this.jstreeUpdate()
		})
	}

	generateTestAI(lesson: number) {
		Swal.fire({
			title: 'Generar evaluación',
			html: "<p>Generando evaluación...</p>",
			timer: 2000,
			showConfirmButton: false,
			allowEscapeKey: false,
			allowOutsideClick: false,
			didOpen: () => {
				Swal.showLoading()
				Swal.stopTimer()
				let htmlContainer = Swal.getHtmlContainer()!

				this.generateTestAISub = this.dataService.generateTestAI(lesson)
				.subscribe({
					next: (result) => {
						console.log(result)
						if (result) {
							htmlContainer.innerHTML = "<p class='text-success'><i class='fas fa-check'></i><span>¡Evaluación generada!</span></p>"
							Swal.hideLoading()
							Swal.resumeTimer()
						}
					},
					error: (e) => {
						console.log(e)

						// htmlContainer.innerHTML = "<p class='text-danger'><i class='fas fa-times'></i><span>Error</span></p>"
						// Swal.hideLoading()
						// Swal.resumeTimer()

						Swal.fire({
							title: 'Error',
							html: '' + e.error.message + '<br>¿Quieres intentarlo de nuevo?',
							icon: 'error',
							showCancelButton: true,
							cancelButtonText: 'Cancelar'
						}).then((result) => {
							// console.log(result)
							if (result.isConfirmed) this.generateTestAI(lesson)
							else this.jstreeUpdate()
						})
					},
				})
			}
		}).then((result) => {
			console.log(result)
			this.jstreeUpdate()
		})
	}

	generateUnitSummaryAI(unit: number) {
		Swal.fire({
			title: 'Generar resumen',
			html: "<p>Generando resumen...</p>",
			timer: 2000,
			showConfirmButton: false,
			allowEscapeKey: false,
			allowOutsideClick: false,
			didOpen: () => {
				Swal.showLoading()
				Swal.stopTimer()
				let htmlContainer = Swal.getHtmlContainer()!

				this.generateUnitSummaryAISub = this.dataService.generateUnitSummaryAI(unit)
				.subscribe({
					next: (result) => {
						console.log(result)
						if (result) {
							htmlContainer.innerHTML = "<p class='text-success'><i class='fas fa-check'></i><span>¡Resumen generado!</span></p>"
							Swal.hideLoading()
							Swal.resumeTimer()
						}
					},
					error: (e) => {
						console.log(e)

						// htmlContainer.innerHTML = "<p class='text-danger'><i class='fas fa-times'></i><span>Error</span></p>"
						// Swal.hideLoading()
						// Swal.resumeTimer()

						Swal.fire({
							title: 'Error',
							html: '' + e.error.message + '<br>¿Quieres intentarlo de nuevo?',
							icon: 'error',
							showCancelButton: true,
							cancelButtonText: 'Cancelar'
						}).then((result) => {
							// console.log(result)
							if (result.isConfirmed) this.generateUnitSummaryAI(unit)
							else this.jstreeUpdate()
						})
					},
				})
			}
		}).then((result) => {
			console.log(result)
			this.jstreeUpdate()
		})
	}

	generateUnitGlossaryAI(unit: number) {
		Swal.fire({
			title: 'Generar glosario',
			html: "<p>Generando glosario...</p>",
			timer: 2000,
			showConfirmButton: false,
			allowEscapeKey: false,
			allowOutsideClick: false,
			didOpen: () => {
				Swal.showLoading()
				Swal.stopTimer()
				let htmlContainer = Swal.getHtmlContainer()!

				this.generateUnitSummaryAISub = this.dataService.generateUnitGlossaryAI(unit)
				.subscribe({
					next: (result) => {
						console.log(result)
						if (result) {
							htmlContainer.innerHTML = "<p class='text-success'><i class='fas fa-check'></i><span>¡Glosario generado!</span></p>"
							Swal.hideLoading()
							Swal.resumeTimer()
						}
					},
					error: (e) => {
						console.log(e)

						// htmlContainer.innerHTML = "<p class='text-danger'><i class='fas fa-times'></i><span>Error</span></p>"
						// Swal.hideLoading()
						// Swal.resumeTimer()

						Swal.fire({
							title: 'Error',
							html: '' + e.error.message + '<br>¿Quieres intentarlo de nuevo?',
							icon: 'error',
							showCancelButton: true,
							cancelButtonText: 'Cancelar'
						}).then((result) => {
							// console.log(result)
							if (result.isConfirmed) this.generateUnitGlossaryAI(unit)
							else this.jstreeUpdate()
						})
					},
				})
			}
		}).then((result) => {
			console.log(result)
			this.jstreeUpdate()
		})
	}

	translateUnitAI(unit: number, transl: string) {
		let command = 'unit_translate'
		let data = {
			'unit_id': unit,
			'transl': transl,
		}

		Swal.fire({
			title: 'Traducir unidad',
			// html: "<p id='job-message'>Empezando...</p><p id='job-progress'>Progreso: 0%</p>",
			html: "<p id='job-message'>Empezando...</p>",
			timer: 2000,
			showConfirmButton: false,
			allowEscapeKey: false,
			allowOutsideClick: false,
			didOpen: () => {
				Swal.showLoading()
				Swal.stopTimer()

				const popup = Swal.getPopup()!
				// const popupProgress = popup.querySelector("p#job-progress")
				const popupMessage = popup.querySelector("p#job-message")

				this.jobAddSub = this.dataService.jobAdd(command, data)
				.subscribe({
					next: (jobId) => {
						console.log(jobId)

						let interval = setInterval(() => {
							this.jobStatusSub = this.dataService.jobStatus(jobId)
							.subscribe({
								next: (data) => {
									console.log(data)
									let status = data.status
									let message = data.message
									// let progress = data.progress

									popupMessage!.textContent = message
									// popupProgress!.textContent = `Progreso: ${progress}%`

									if (status == 'completed') {
										// popupMessage!.innerHTML = `<p class='text-success'><i class='fas fa-check'></i><span>${message}</span></p>`
										popupMessage!.innerHTML = `<p class='text-success'><i class='fas fa-check'></i><span>¡Completado!</span></p>`
										clearInterval(interval)
										Swal.hideLoading()
										Swal.resumeTimer()
										// this.jstreeUpdate()
									} else if (status == 'failed') {
										popupMessage!.innerHTML = 'Error'
										clearInterval(interval)
										Swal.hideLoading()
										Swal.resumeTimer()
									}
								},
								error: (e) => {
									console.log(e)
									clearInterval(interval)
									// this.jstreeUpdate()
									Swal.hideLoading()
									Swal.resumeTimer()
								}
							})
						}, 1000)
					},
					error: (e) => {
						console.log(e)
					}
				})
			},
		}).then((result) => {
			console.log(result)
			this.jstreeUpdate()
		})
	}

	translateLessonAI(lesson: number, transl: string) {
		console.log(lesson)
		console.log(transl)
		Swal.fire({
			title: 'Traducir lección',
			html: "<p>Traduciendo lección...</p>",
			timer: 2000,
			showConfirmButton: false,
			allowEscapeKey: false,
			allowOutsideClick: false,
			didOpen: () => {
				Swal.showLoading()
				Swal.stopTimer()
				let htmlContainer = Swal.getHtmlContainer()!

				this.translateLessonAISub = this.dataService.translateLessonAI(lesson, transl)
				.subscribe({
					next: (result) => {
						console.log(result)
						if (result) {
							htmlContainer.innerHTML = "<p class='text-success'><i class='fas fa-check'></i><span>¡Lección traducida!</span></p>"
							Swal.hideLoading()
							Swal.resumeTimer()
						}
					},
					error: (e) => {
						console.log(e)

						let errorMsg = e.error.message
						if (errorMsg == undefined) errorMsg = ""

						Swal.fire({
							title: 'Error',
							html: `<p>${errorMsg}</p><p>¿Quieres intentarlo de nuevo?</p>`,
							icon: 'error',
							showCancelButton: true,
							cancelButtonText: 'Cancelar'
						}).then((result) => {
							// console.log(result)
							if (result.isConfirmed) this.translateLessonAI(lesson, transl)
							else this.jstreeUpdate()
						})
					},
				})
			}
		}).then((result) => {
			console.log(result)
			this.jstreeUpdate()
		})
	}

	exportBrainscorm() {
		let userName = this.dataService.getUserName()
		let courseName = this.dataService.getCourseName()
		this.bsExporting = true
		this.exportBrainscormSub = this.dataService.exportBrainscorm(this.userID, userName, this.courseID, courseName)
		.subscribe({
			next: (result) => {
				console.log(result)
				this.bsExporting = false
				if (result) {
					Swal.fire('Listo', `El curso ha sido exportado. Acceda a brainscorm.com y busque el curso "${courseName}" en la carpeta "Exportados MotorIA: ${userName} (${this.userID})`, 'success')
				}
			},
			error: (e) => {
				console.log(e)
				this.bsExporting = false
				Swal.fire('Error', 'Ha habido un error. Por favor, inténtelo de nuevo.', 'error')
			},
		})
	}
}